import React, { createContext, useContext } from 'react'
import { createPortal } from 'react-dom'

// The page header's action slot (V4: New order, New load sit in the header
// bar, right-aligned). The page owns the header; the list view owns the
// button and its state, so the view renders the button into the slot. With
// no slot (a view rendered on its own) the button stays where it is.
export const HeaderSlotContext = createContext<HTMLElement | null>(null)

export function HeaderAction({ children }: { children: React.ReactNode }) {
  const slot = useContext(HeaderSlotContext)
  return slot ? createPortal(children, slot) : <>{children}</>
}

// V4's download arrow on "Export current results".
export function ExportIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2.75} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 3v12" />
      <path d="m7 10 5 5 5-5" />
      <path d="M5 21h14" />
    </svg>
  )
}
